<template>
  <transition name="fade">
    <div class="scanner" v-if="$route.meta.scanExpectations && q !== ''">{{ q }}</div>
  </transition>
</template>

<script>
import { EventBus } from '@/EventBus'
import { scanMixin } from '@/mixins/scanMixin'

export default {
  data() {
    return {
      q: '',
      scanExpectations: null
    }
  },
  mixins: [scanMixin],
  mounted() {
    window.addEventListener('keydown', e => {
      if (!e.ctrlKey && !e.metaKey && e.target.tagName !== 'INPUT') {
        switch (e.key) {
          case 'Enter':
            this.submitScan()
            break
          case 'Backspace':
            if (e.altKey) {
              this.q = ''
            } else {
              this.q = this.q.slice(0, -1)
            }
            break
          default:
            if (e.key.length === 1) {
              this.q = this.q + e.key
            }
            break
        }
      }
    })
  },
  methods: {
    submitScan() {
      const { scanExpectations } = this.$route.meta
      if (scanExpectations) {
        console.log(`🔎 scanned ${this.q} while searching for ${scanExpectations}`)
        let validTypeFound = false
        scanExpectations.forEach(type => {
          if (!validTypeFound && this.validateScanType({ type, q: this.q }) === true) {
            validTypeFound = type
          }
        })
        EventBus.$emit('scan', {
          validTypeFound,
          q: this.q,
          result: validTypeFound ? this.getScanResult({ type: validTypeFound, q: this.q }) : null
        })
        this.q = ''
      }
    }
  },
  watch: {
    $route() {
      this.q = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.scanner {
  background: yellowgreen;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to {
  opacity: 0;
}
</style>
